import { useEffect, useRef, useState } from 'react';
import { createStaffSocket } from '../../../lib/socket';

export default function useServiceSocket({ onSync, onOrderCreated, onOpenRequested }) {
  const [state, setState] = useState('connecting');
  const onSyncRef = useRef(onSync);
  const onOrderRef = useRef(onOrderCreated);
  const onRequestRef = useRef(onOpenRequested);

  useEffect(() => {
    onSyncRef.current = onSync;
    onOrderRef.current = onOrderCreated;
    onRequestRef.current = onOpenRequested;
  }, [onSync, onOrderCreated, onOpenRequested]);

  useEffect(() => {
    const socket = createStaffSocket();
    const sync = () => onSyncRef.current?.();

    socket.on('connect', () => {
      setState('connected');
      sync();
    });
    socket.on('disconnect', () => setState('disconnected'));
    socket.on('connect_error', (err) => {
      setState(err?.data?.code || 'error');
      if (err?.data?.code === 'auth_expired') {
        localStorage.removeItem('neon_token');
        localStorage.removeItem('token');
        localStorage.removeItem('neon_user');
        window.dispatchEvent(new Event('neon-auth-expired'));
      }
    });

    socket.on('order:created', (payload) => {
      onOrderRef.current?.(payload);
      sync();
    });
    socket.on('order:status_changed', sync);
    socket.on('table:opened', sync);
    socket.on('table:closed', sync);
    socket.on('table:urgency', sync);
    socket.on('invoice:issued', sync);
    socket.on('invoice:cancelled', sync);
    socket.on('cashclose:created', sync);

    // Solicitudes de apertura de mesa (cliente desde QR)
    socket.on('table:open_requested', (payload) => {
      onRequestRef.current?.(payload);
      sync();
    });
    socket.on('table:open_request_cancelled', sync);
    socket.on('table:open_request_accepted', sync);
    socket.on('table:open_request_rejected', sync);

    return () => socket.close();
  }, []);

  return state;
}
